<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2251_4461)">
<rect x="2.85" y="6.52175" width="17.3" height="10.3" rx="5.15" stroke="currentColor" stroke-width="1.7"/>
<rect x="7.83789" y="10.9717" width="7.32415" height="1.4" rx="0.7" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2251_4461">
<rect width="22" height="22" fill="white" transform="translate(0.5 0.671753)"/>
</clipPath>
</defs>
</svg>
